import React, { Component } from 'react';

import UserModel from './UserModel'

import { Table, Popconfirm } from 'antd';

class AutoParkinglocationTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Lokalita',
    dataIndex: 'ParkingLocationName',
    key: 'ParkingLocationName',
  }, {
    title: 'Popis',
    dataIndex: 'Description',
    key: 'Description',
  }, {
    title: 'Identifikátor zóny',
    dataIndex: 'ZoneID',
    key: 'ZoneID',
    width: '300px',
  }, {
    title: 'Zóna přehledové kamery',
    dataIndex: 'IsZoneDetections',
    key: 'IsZoneDetections',
    width: '175px',
    render: (text, record) => {
      return text ? 'Ano' : 'Ne';
    },
  }, {
    title: 'Akce',
    key: 'Action',
    width: 100,
    render: (text, record) => {
      if (UserModel.isInRoles(['ADMIN', 'PARKDETECT_PARKINGLOCATIONS_WRITE'])) {
        return (
          <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
            this.props.onRemoveRow(record.id)
          }} okText="Ano" cancelText="Ne">
            <a onClick={(e) => { e.preventDefault(); }}>Smazat</a>
          </Popconfirm>
        );
      }
    }
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        style={{ border: '0px' }} />
    );
  }
}

export default AutoParkinglocationTable;


// WEBPACK FOOTER //
// ./src/components/AutoParkinglocationTable.js